const EDITABLE_SELECTOR = 'input, textarea, select, [contenteditable="true"], [contenteditable=""]';

const isEditableTarget = (target) =>
  target instanceof Element && target.closest(EDITABLE_SELECTOR) !== null;

const blockUnlessEditable = (event) => {
  if (!isEditableTarget(event.target)) {
    event.preventDefault();
  }
};

/**
 * Blocks copy/cut/right-click on normal page content site-wide, while
 * leaving inputs, textareas, and contenteditable elements fully usable
 * (type, select, cut, copy, paste). Returns a cleanup function.
 */
export const attachContentProtection = () => {
  document.addEventListener('copy', blockUnlessEditable);
  document.addEventListener('cut', blockUnlessEditable);
  document.addEventListener('contextmenu', blockUnlessEditable);

  return () => {
    document.removeEventListener('copy', blockUnlessEditable);
    document.removeEventListener('cut', blockUnlessEditable);
    document.removeEventListener('contextmenu', blockUnlessEditable);
  };
};
